import { render, staticRenderFns } from "./tSalesExport.vue?vue&type=template&id=6771c095&scoped=true"
import script from "./tSalesExport.vue?vue&type=script&lang=js"
export * from "./tSalesExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6771c095",
  null
  
)

export default component.exports